import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetTestITData = createAsyncThunk(
    'InventoryTransfer/fetchTestITData',
    async ({search_term, prev_value,search_field}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`InventoryTransfer/GetTestItInput?search_term=${search_term}&prev_value=${prev_value}&search_field=${search_field}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const GetItemByBatch = createAsyncThunk(
    'InventoryTransfer/fetchItemDetails',
    async ({ item_Code, batch_Number }, { rejectWithValue }) => {
      try {
        const response = await apiClient.get(
          `InventoryTransfer/GetItInput?BatchNum=${batch_Number}&ItemCode=${item_Code}`
        );
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching item details');
      }
    }
  );

  export const postITR = createAsyncThunk(
    'InventoryTransfer/postITR',  // Action name for redux
    async (tableBody, { rejectWithValue }) => {
      try {
        // Make the POST request with updatedRows as the payload
        const response = await apiClient.post('InventoryTransfer/PostItInput', tableBody);
        return response.data;  // Return the response data to be stored in Redux
      } catch (error) {
        // Handle the error and return it with rejectWithValue for better error handling
        return rejectWithValue(error.response?.data || 'Error posting Inventory Transfer');
      }
    }
  );
  
  export const GetToWhs = createAsyncThunk(
    'InventoryTransfer/GetToWhs',
    async (_, { rejectWithValue }) => {
      try {
        const response = await apiClient.get(
          `InventoryTransfer/GetToWhs`
        );
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching item details');
      }
    }
  );